<page-header [section]="'wipfli-synch-queue-list'">
  <page-title>Wipfli Synch Queue List</page-title>
  <page-blurb>View and manage Wipfli Sync Queue.</page-blurb>
</page-header>
